import { FhsAxios } from "../../services/axios";
import vue from "vue";

export const Portfoilo_MODULE = {
  state: {
    portfolio_sum: null,
    portfolio_details: null,
    portfolio_sort_list: [
      {
        value: "STOCK_TYPE_NAME",
        text: "По финансовым инструментам",
        selected: true
      },
      {
        value: "COUNTRY",
        text: "По странам",
        selected: false
      },
      {
        value: "SECTOR_ECONOMY",
        text: "По секторам",
        selected: false
      },
      {
        value: "CURRENCY",
        text: "По валютам",
        selected: false
      }
    ]
  },
  getters: {
    getPortfolioSum: state => state.portfolio_sum || {},
    getPortfolioLoading: state =>
      state.portfolio_sum === null || state.portfolio_details === null,
    getPortfolioSumByCurrency: (state, getters) =>
      getters.getPortfolioSum[getters.getSelectedCurrency] || {},
    getPortfolioSumByCurrencyGiven: (state, getters) => currency =>
      getters.getPortfolioSum[currency] || {},
    getPortfolioDetails: state => state.portfolio_details || [],
    getPortfolioSortTypesList: state => state.portfolio_sort_list,
    getPortfolioSortTypeSelected: (state, getters) =>
      getters.getPortfolioSortTypesList.filter(type => type.selected)[0] || {},
    getPortfolioDetailsCategory: (state, getters) => (drildown = false) => {
      let result = {
        Другие: []
      };
      let sort_type = getters.getPortfolioSortTypeSelected.value;
      getters.getPortfolioDetails.forEach(p => {
        let category = {
          category: drildown ? `${p["TICKER"]} (${p["ISIN"]})` : p[sort_type],
          value: p["MONEY"][getters.getSelectedCurrency]
        };
        if (result[p[sort_type]]) {
          result[p[sort_type]].push(category);
        } else {
          if (p[sort_type] === null) {
            // console.log(sort_type);
            if (drildown) {
              category.category = `${p["TICKER"]} (${p["ISIN"]})`;
            } else {
              category.category = `Другие`;
            }
            result["Другие"].push(category);
          } else {
            result[p[sort_type]] = [];
            result[p[sort_type]].push(category);
          }
        }
      });
      return result;
    },
    getPortfolioDetailsCategoryForChart: (state, getters) => {
      let data = getters.getPortfolioDetailsCategory();
      let money_data = getters.getMoneyForPortfolioChart;
      let portfolio_data =
        Object.entries(data).map(category => {
          let chart_category = {
            category: "",
            value: 0
          };
          category[1].forEach(each => {
            chart_category.category = each.category;
            chart_category.value += parseFloat(each.value || null);
          });
          return chart_category;
        }) || [];
      let result = {
        data: [...money_data, ...portfolio_data],
        total: 0
      };
      result.data.forEach(each => {
        result.total += parseFloat(each.value || 0);
      });
      return result;
    }
  },
  mutations: {
    setPortfolioSumData: (state, payload) => (state.portfolio_sum = payload),
    setPortfolioDetailsData: (state, payload) =>
      (state.portfolio_details = payload),
    setPortfolioSortCondition: (state, payload) => {
      state.portfolio_sort_list.forEach(sort_type => {
        sort_type.selected = sort_type.value === payload;
      });
    }
  },
  actions: {
    fetchUserPortfolioData({ commit, getters }) {
      commit("setPortfolioSumData", null);
      commit("setPortfolioSumData", null);
      let portfolio_id =
        getters.selectedPortfolio === "all"
          ? ""
          : "/" + getters.selectedPortfolio || "";
      return FhsAxios.get(`user/currency-portfolio${portfolio_id}`).then(
        res => {
          if (res.data.status) {
            commit(
              "setPortfolioSumData",
              res.data.result.currencyPortfolioSum || {}
            );
            commit(
              "setPortfolioDetailsData",
              res.data.result.currencyPortfolioDetails || []
            );
            return Promise.resolve(res.data.result);
          } else {
            commit("setPortfolioSumData", {});
            commit("setPortfolioSumData", []);
            return Promise.reject(res);
          }
        }
      );
    }
  }
};
